"use client";

import { DEFAULT_LANDING_PAGE_CONFIG } from "../../constants/landing-page-config";

export type LandingConfig = typeof DEFAULT_LANDING_PAGE_CONFIG;

export const staticAssets = {
  weddingMark: "/images/logo/logo4.png",
  decorLine: "/images/logo/logo4.png",
} as const;

export const coverImage = "/images/own-images/IMG_5735.jpg";
export const featuredImage = "/images/own-images/IMG_5836.jpg";

export const WEDDING_DATE = new Date(Date.UTC(2027, 4, 14, 10, 0, 0));

export function getCountdownParts() {
  const now = Date.now();
  const diff = Math.max(WEDDING_DATE.getTime() - now, 0);
  const days = Math.floor(diff / (1000 * 60 * 60 * 24));
  const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
  const minutes = Math.floor((diff / (1000 * 60)) % 60);
  const seconds = Math.floor((diff / 1000) % 60);

  return { days, hours, minutes, seconds };
}

export const galleryPhotos = [
  {
    id: "photo-1",
    alt: "រូបថតអនុស្សាវរីយ៍គូស្វាមីភរិយា",
    src: "https://images.unsplash.com/photo-1520854221256-17451cc331bf?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "photo-2",
    alt: "រូបថតថ្ងៃមង្គលដ៏ស្រស់ស្អាត",
    src: "https://images.unsplash.com/photo-1511285560929-80b456fea0bc?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "photo-3",
    alt: "អនុស្សាវរីយ៍ពិសេសរបស់គូស្នេហ៍",
    src: "https://images.unsplash.com/photo-1519741497674-611481863552?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "photo-4",
    alt: "ស្នាមញញឹមក្នុងថ្ងៃអាពាហ៍ពិពាហ៍",
    src: "https://images.unsplash.com/photo-1515934751635-c81c6bc9a2d8?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "photo-5",
    alt: "ពេលវេលារំភើបនៃថ្ងៃជ័យមង្គល",
    src: "https://images.unsplash.com/photo-1516589178581-6cd7833ae3b2?auto=format&fit=crop&w=1200&q=80",
  },
  {
    id: "photo-6",
    alt: "កម្រងរូបភាពស្នេហាអមតៈ",
    src: "https://images.unsplash.com/photo-1519225421980-715cb0215aed?auto=format&fit=crop&w=1200&q=80",
  },
] as const;

export type GalleryPhoto = (typeof galleryPhotos)[number];

export const weddingTimeline = [
  {
    id: 1,
    time: "ម៉ោង ៦ : ៣០ ពេលព្រឹក",
    description: "ជួបជុំភ្ញៀវកិត្តិយស",
  },
  {
    id: 2,
    time: "ម៉ោង ៧ : ០០ ពេលព្រឹក",
    description: "ជួបជុំភ្ញៀវកិត្តិយសរៀបចំពិធីហែជំនូននៅគេហដ្ឋានកូនស្រី",
  },
  {
    id: 3,
    time: "ម៉ោង ៧ : ៣០ ពេលព្រឹក",
    description: "ពិធីហែជំនូន ចូលរោងជ័យ និងអញ្ជើញភ្ញៀវកិត្តិយសពិសារអាហារពេលព្រឹក",
  },
  {
    id: 4,
    time: "ម៉ោង ៨ : ១៥ ពេលព្រឹក",
    description: "ពិធីជូនបណ្តាការ ពិសារស្លា និងបំពាក់ជញ្ជៀន",
  },
  {
    id: 5,
    time: "ម៉ោង ៩ : ០០ ពេលព្រឹក",
    description: "ពិធីកាត់សក់ បង្កក់សិរី កូនប្រុស កូនស្រី",
  },
  {
    id: 6,
    time: "ម៉ោង ១១ : ០០ ពេលព្រឹក",
    description: "ពិធីសំពះផ្ទឹមចងដៃ បង្វិលពពិល និងព្រះថោងតោងស្បៃ",
  },
  {
    id: 7,
    time: "ម៉ោង ១២ : ០០ ពេលថ្ងៃត្រង់",
    description: "អញ្ជើញភ្ញៀវកិត្តិយសពិសារអាហារ​ថ្ងៃត្រង់",
  },
  {
    id: 8,
    time: "ម៉ោង ៥ : ០០ ពេលល្ងាច",
    description: "អញ្ជើញភ្ញៀវកិត្តិយសពិសារភោជនាហារ",
  },
] as const;

export const contactNumbers = ["092 208 280"] as const;

export const dressPalette = ["#ffffff", "#0b193c", "#706e8a", "#f4afb4", "#a61c1c"] as const;

export function CalendarIcon({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M7 3V6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M17 3V6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path d="M4 9H20" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <rect x="4" y="5" width="16" height="15" rx="3" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

export function MapPinIcon({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path
        d="M12 21C15.5 16.8 18 13.8 18 10.2C18 6.78 15.31 4 12 4C8.69 4 6 6.78 6 10.2C6 13.8 8.5 16.8 12 21Z"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinejoin="round"
      />
      <circle cx="12" cy="10" r="2.3" stroke="currentColor" strokeWidth="1.8" />
    </svg>
  );
}

export function DownloadIcon({ className = "h-5 w-5" }: { className?: string }) {
  return (
    <svg className={className} viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <path d="M12 4V14" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      <path
        d="M8 10L12 14L16 10"
        stroke="currentColor"
        strokeWidth="1.8"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M5 19H19" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
    </svg>
  );
}
